exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._15DbEJbn28DpeUUMfn2r_E{cursor:default;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._2ztt0neYo_j9Pfa71zpNou{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-color:#a4a4a4;color:#fff;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-webkit-flex:0;-moz-box-flex:0;-ms-flex:0;flex:0;font-size:.71429rem;font-weight:400;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;letter-spacing:.07143rem;padding:.35714rem;text-transform:uppercase;white-space:nowrap}._2ztt0neYo_j9Pfa71zpNou._3nUYR2AvNo_d9cXts5GyTb{background-color:#74d17f}._2ztt0neYo_j9Pfa71zpNou._1WTgIptoyzmFSx-KW4nOu3{background-color:#f7932d}._2ztt0neYo_j9Pfa71zpNou._1PEORBHEfjhBon0n7oJ1r6{background-color:#a4a4a4}._2ztt0neYo_j9Pfa71zpNou._3mjGyitOoNXoYN1SoiKduu{background-color:#de4c4c}._2ztt0neYo_j9Pfa71zpNou._3Z3cBlAnWJYcenrLu16Rzy{background-color:#92205f}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"IndividualDevelopmentPlanStatus": "_15DbEJbn28DpeUUMfn2r_E",
	"IndividualDevelopmentPlanStatus_inner": "_2ztt0neYo_j9Pfa71zpNou",
	"__ready": "_3nUYR2AvNo_d9cXts5GyTb",
	"__sent": "_1WTgIptoyzmFSx-KW4nOu3",
	"__published": "_1PEORBHEfjhBon0n7oJ1r6",
	"__missing": "_3mjGyitOoNXoYN1SoiKduu",
	"__rejected": "_3Z3cBlAnWJYcenrLu16Rzy"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./components/IndividualDevelopmentPlanStatus/style.postcss
// module id = 1767
// module chunks = 0